export const initDopplerNavbar = dopplerConfig => {
  window['style-guide-configuration'] = {
    initFonts: true,
  };
  assetServices.load({
    manifestURL: `${dopplerConfig.dopplerStyleGuide}?s=${Date.now()}`,
  });

  window['doppler-session-mfe-configuration'] = {
    dopplerLegacyBaseUrl: dopplerConfig.dopplerLegacyBaseUrl,
    useDummies: false,
  };
  assetServices.load({
    manifestURL: `${dopplerConfig.dopplerSessionMfe}?s=${Date.now()}`,
  });

  window['doppler-menu-mfe-configuration'] = {
    dopplerMenuElementId: 'doppler-menu-mfe',
    dopplerLegacyBaseUrl: dopplerConfig.dopplerLegacyBaseUrl,
    beamerId: dopplerConfig.beamerId,
  };
  assetServices.load({
    manifestURL: `${dopplerConfig.dopplerMenuMfe}?s=${Date.now()}`,
  });

  // Doppler events to get information
  /* window.addEventListener("doppler-session-state-update", () => {
        console.log(window.dopplerSessionState);
    });
    
    window.addEventListener("DOMContentLoaded", () => {
        console.log(window.dopplerSessionState);
    }); */
};
